'use client';
import React, { useLayoutEffect, useRef, useState } from 'react';

import { isEmpty, size as Size } from 'lodash';

import Input from '../Input/Input';
import Backdrop from '../Backdrop/Backdrop';
import DatePicker from '../Calendar/DatePicker';

import styles from './datePickerInput.module.scss';
import { formatDateAccordingToDateType, getAbsoluteCoordinates, isValidDate } from './helper';
import { ICON_TYPES } from '../icons';

export interface DatePickerInputProps {
  date?: Date;
  setDate: (date?: Date) => void;
  placeholder?: string;
  width?: string;
  label?: string;
  size?: 'small' | 'medium' | 'large';
  isRequired?: boolean;
  error?: string;
  supportText?: string;
  id: string;
}

const DatePickerInput: React.FC<DatePickerInputProps> = (props) => {
  const {
    date,
    setDate,
    placeholder = 'DD/MM/YYYY',
    width,
    size = 'small',
    isRequired = false,
    label,
    error,
    supportText,
    id = 'datePickerInput',
  } = props;

  const [visible, setVisible] = useState(false);
  const [userDate, setUserDate] = useState('');
  const [cordinates, setCordinates] = useState({
    top: 0,
    left: 0,
  });

  const triggerRef = useRef<HTMLInputElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);

  // const isValidDay = (day: number) => day >= 1 && day <= 31;
  // const isValidMonth = (month: number) => month >= 1 && month <= 12;
  // const isValidYear = (year: number78) => year >= 1000 && year <= new Date().getFullYear();

  const handleClick = (val: Date) => {
    const date = formatDateAccordingToDateType(new Date(val), 'DD/MM/YYYY');
    setUserDate(date);

    setDate(val); // Parse the formatted date string back into a Date object
    setVisible(false);
    // setUserDate('');
  };

  const handleDateChange = (val: string) => {
    let value = val;

    const numbers = value.replace(/[^\d]/g, '');

    // const day = numbers.length >= 2 ? numbers.slice(0, 2) : '';
    // const month = numbers.length >= 4 ? numbers.slice(2, 4) : '';
    // const year = numbers.length > 4 ? numbers.slice(4, 8) : '';

    // if (
    //   (day && !isValidDay(Number(day))) ||
    //   (month && !isValidMonth(Number(month))) ||
    //   (year && year.length === 4 && !isValidYear(Number(year)))
    // ) {
    //   return; // Don't update the state if the day, month, or year is invalid
    // }

    if (numbers.length < 3) {
      if (numbers.length === 1 && numbers > '3') {
        value = '0' + numbers;
      } else if (numbers.length === 2 && numbers > '31') {
        value = '0' + numbers[1];
      } else {
        value = numbers.substring(0, 2);
      }

      // if (numbers.length === 2 && numbers > '31') {
      //   value = '03';
      // } else {
      //   value = numbers;
      // }
      // value = numbers;
    } else if (numbers.length < 5) {
      if (numbers.length === 3 && numbers[2] > '1') {
        value = `${numbers.slice(0, 2)}/0${numbers.slice(2)}`;
      } else if (numbers.length === 4 && numbers.slice(2) > '12') {
        value = `${numbers.substring(0, 2)}/0${numbers[3]}`;
      } else {
        value = `${numbers.slice(0, 2)}/${numbers.slice(2)}`;
      }

      // value = `${numbers.slice(0, 2)}/${numbers.slice(2)}`;
    } else {
      value = `${numbers.slice(0, 2)}/${numbers.slice(2, 4)}/${numbers.slice(4, 8)}`;
    }

    setUserDate(value);

    if (Size(value) === 10) {
      const newDate = isValidDate(value);

      if (newDate) {
        setDate(new Date(newDate));
      }
    }

    if (isEmpty(value)) {
      setDate(undefined);
      return;
    }
  };

  useLayoutEffect(() => {
    if (!contentRef.current || !triggerRef.current) return;

    const { height: contentHeight, width: contentWidth } =
      contentRef.current.getBoundingClientRect();
    const { height, width, x, y } = triggerRef.current.getBoundingClientRect();

    const { left, top } = getAbsoluteCoordinates(
      height,
      width,
      contentHeight,
      contentWidth,
      'bottomLeft',
      x,
      y,
    );

    setCordinates({
      top,
      left,
    });
  }, [visible]);

  const hasError = !isEmpty(error);

  return (
    <div className={styles.DatePickerInput}>
      <Backdrop visible={visible} setVisible={setVisible} isTransparent />
      <div ref={triggerRef}>
        <Input
          placeholder={placeholder}
          // max="1979-12-31"
          label={label}
          isRequiredField={isRequired}
          value={userDate || (date && formatDateAccordingToDateType(date))}
          type="string"
          suffixIcon={ICON_TYPES.CALENDAR}
          onChange={(val) => {
            // setUserDate(val);
            // setDate(new Date(val));
            handleDateChange(val);
          }}
          id={id}
          onSuffixIconClick={() => setVisible(!visible)}
          width={width || '250px'}
          size={size}
          containerClassName={styles.inputContainer}
          validation={{
            status: hasError ? 'error' : undefined,
            text: hasError ? error : supportText,
            // className: hasError ? errorClassName : supportTextClassName,
          }}
        />
      </div>
      <div style={{ position: 'absolute', ...cordinates, zIndex: 1 }}>
        <DatePicker
          ref={contentRef}
          visible={visible}
          setVisible={setVisible}
          date={!date ? new Date() : date}
          setDate={handleClick}
        />
      </div>
    </div>
  );
};

export default DatePickerInput;
